<section id="filterContainer">
    <article class="pl-5 pt-5">
        <h1 class="title">{{ literalService.get('filterBy', true) }}</h1>
    </article>
    <article class="lg:flex sm:relative pl-5 pt-5 pr-5">
        @if (clients.length > 1) {
          <label class="w-48 text-center title-columns mr-4">{{ literalService.get('messages.data.client', true) }}</label>
        }
        <label class="w-48 text-center title-columns mr-4">{{ literalService.get('messages.data.from', true) }}</label>
        <label class="w-48 text-center title-columns mr-4">{{ literalService.get('messages.data.receiver', true) }}</label>
    </article>
    <form #form novalidate>
        <article class="lg:flex sm:relative pl-5 pt-5 pr-5">
          @if (clients.length > 1) {
            <article class="lg:flex rounded w-48 items-start mr-4">
                <app-multi-select-form [title]="'message-clients'" [elements]="clients" [values]="selectedValuesClients" [width]="'48'" />
            </article>
          }
            <article class="lg:flex rounded w-48 items-start mr-4">
                <app-multi-select-form [title]="'suggestion-from'" [elements]="senders" [values]="selectedSenders" [width]="'48'" [orderById]="false" />
            </article>
            <article class="lg:flex flex-col rounded w-48 min-h-24 items-start mr-4 gap-2">
                <select2 class="block w-48" [data]="receivers" [value]="selectedReceiver" [templates]="{option: option}" (update)="changeData($event, 'receiverType')">
                    <ng-template #option let-label="label">
                        <app-select2-option [label]="label" />
                    </ng-template>
                </select2>
                @if (selectedReceiver) {
                    @if (selectedReceiver === MessageReceiver.EXPEDITION) {
                        <app-input
                            class="w-48"
                            [data]="expeditionServicesElement"
                            [edit]="true"
                            [independent]="true"
                            (setEventEmitter)="changeData($event.value, expeditionServicesElement.edit?.valueToChange)"
                            (scrollEventEmitter)="scroll($event, expeditionServicesElement.edit?.valueToChange)"
                            (searchEventEmitter)="search($event, expeditionServicesElement.edit?.valueToChange)"
                        />
                        <app-input
                            class="w-48"
                            [data]="expeditionRoutesElement"
                            [edit]="true"
                            [independent]="true"
                            (setEventEmitter)="changeData($event.value, expeditionRoutesElement.edit?.valueToChange)"
                            (scrollEventEmitter)="scroll($event, expeditionRoutesElement.edit?.valueToChange)"
                            (searchEventEmitter)="search($event, expeditionRoutesElement.edit?.valueToChange)"
                        />
                    }
                    <app-input
                        class="w-48"
                        [data]="receiverElement"
                        [edit]="true"
                        [independent]="true"
                        (setEventEmitter)="changeData($event.value, receiverElement.edit?.valueToChange)"
                        (scrollEventEmitter)="scroll($event, receiverElement.edit?.valueToChange)"
                        (searchEventEmitter)="search($event, receiverElement.edit?.valueToChange)"
                    />
                }
            </article>
        </article>
        <article class="pt-10 pl-5 pb-5">
            <article class="flex pt-5 place-content-between">
                <div class="flex">
                    <label class="lg:flex box pt-2 pb-2 pl-4 pr-4 rounded w-48 h-12 mr-4 mb-2 items-center cursor-pointer">
                        <input #select type="checkbox" class="mr-2 cursor-pointer" (change)="selectAll($event)" />
                        {{ literalService.get('selectAll', true) }}
                    </label>
                    <article class="lg:flex box pt-2 pb-2 pl-4 pr-4 rounded w-40 h-12 mr-4 mb-2 items-center cursor-pointer bg-white" (click)="clearSelection()">
                        <img [src]="images.trash" class="h-5 w-5 mr-2 cursor-pointer" alt="clearSelection" />
                        <label class="cursor-pointer hover:underline">{{ literalService.get('clearSelection', true) }}</label>
                    </article>
                </div>
                <article class="lg:flex box pt-2 pb-2 pl-4 pr-4 rounded w-48 h-12 mr-4 mb-2 items-center">
                    <input type="button" class="primary text-white gap-4 p-2 border-2 font-semibold h-12 w-48 uppercase cursor-pointer" [value]="literalService.get('filter', true)" (click)="onSubmit(); closeFilter.emit()" />
                </article>
            </article>
        </article>
    </form>
</section>

